export const parseDuration = (
  min: number | null | undefined
): { fullStr: string; hr: string; mins: string } => {
  const hr = min
    ? Math.floor(min / 60) < 10
      ? "0" + Math.floor(min / 60)
      : Math.floor(min / 60)
    : "";

  const mins = min
    ? Math.floor(min % 60) < 10
      ? "0" + Math.floor(min % 60)
      : Math.floor(min % 60)
    : "";

  return {
    fullStr: hr.toString() + mins.toString(),
    hr: hr.toString(),
    mins: mins.toString(),
  };
};

export const durationStrToMinutes = (
  value?: string | null
): number | null => {
  if (!value) {
    return null;
  }

  const cleaned = value.replace(/[^0-9]/g, "");

  if (!cleaned) {
    return null;
  }

  const padded = cleaned.padStart(4, "0").slice(-4);
  const hrPart = padded.slice(0, 2);
  const minPart = padded.slice(2, 4);

  const hr = hrPart ? parseInt(hrPart, 10) : 0;
  const mins = minPart ? parseInt(minPart, 10) : 0;

  if (Number.isNaN(hr) && Number.isNaN(mins)) {
    return null;
  }

  return hr * 60 + mins;
};

/** Total minutes → calculator-style digits for MaskedDurationInput (e.g. 90 → "130"). */
export const minutesToTypedDigits = (
  minutes: number | null | undefined
): string => {
  if (minutes == null) return "";
  const fullStr = parseDuration(minutes).fullStr;
  if (!fullStr) return "";
  return fullStr.replace(/^0+/, "") || "";
};

/** MaskedDurationInput digits → 4-char HHMM storage (e.g. "0230"). */
export const durationDigitsToStorage = (digits: string): string | null => {
  const cleaned = digits.replace(/[^0-9]/g, "");
  if (!cleaned) return null;
  return cleaned.padStart(4, "0").slice(-4);
};

/** Stored HHMM → `00h:00m` display. */
export const durationStorageToDisplay = (
  stored: string | null | undefined
): string => {
  if (!stored?.trim()) return "";
  const digits = stored.replace(/[^0-9]/g, "").padStart(4, "0").slice(-4);
  return `${digits.slice(0, 2)}h:${digits.slice(2, 4)}m`;
};
